import React from "react";

const TrainingIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 20H16M14 20C13.1716 20 12.5 19.3284 12.5 18.5V16H12M14 20H10M12 16H11.5V18.5C11.5 19.3284 10.8284 20 10 20M12 16V20M10 20H8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 2H4C2.89543 2 2 2.89543 2 4V14C2 15.1046 2.89543 16 4 16H20C21.1046 16 22 15.1046 22 14V4C22 2.89543 21.1046 2 20 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 9L10 6V12L15 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrainingIcon;
